module.exports = __webpack_public_path__ + "static/media/Advocate.5e91c2c4.png";